<template>
  <div class="select__wrapper">
    <div>
      <label class="select__label"
        ><span class="select__title font-16 grey400 font-20"
          >Selecione o tamanho</span
        ><select
          v-model="selectedValue"
          @change="$emit('setValue', selectedValue)"
          class="select__input font-16 blue600 head-bold"
        >
          <option
            v-for="(tamanho, $t) in data"
            :key="$t"
            :value="tamanho.id_produto_variacao"
          >
            {{ tamanho.value }}
          </option></select
        ><span class="select__svgwrapper"
          ><span class="StyledIcon-sc-6xpssa dEfTaA"
            ><svg
              aria-hidden="true"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
            >
              <path
                d="m1.984 6.19 9.465 9.893c.28.299.418.397.551.397.145 0 .31-.114.572-.392l9.443-9.898.962.918-9.439 9.893a2.108 2.108 0 0 1-1.538.81 2.083 2.083 0 0 1-1.517-.813l-9.46-9.889z"
              ></path></svg></span></span
      ></label>
      <div class="text-right">
        <a
          class="font-12 grey400"
          :href="$epecaHubB2c.configJson.FILES_BOUTIQUE_SIZE_GUIDE"
          target="_blank"
          >Guia de tamanhos</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.selectedValue = this.active;
  },
  data() {
    return {
      selectedValue: null,
    };
  },
  props: {
    data: {
      type: Array,
      default: [],
    },
    active: {
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
.select {
  &__label {
    position: relative;
    display: block;
    color: rgb(0, 30, 80);
    cursor: pointer;
  }
  &__title {
    width: 100%;
    display: flex;
    transition: color 300ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
    pointer-events: none;
  }
  &__input {
    appearance: none;
    height: calc(1.15em + 16px);
    width: 100%;
    padding: 8px 32px 8px 0px;
    border: 0px;
    border-radius: 0px;
    box-shadow: rgb(106 118 125) 0px 1px 0px 0px;
    color: inherit;
    background: transparent;
    outline: none;
    cursor: pointer;
  }
  &__svgwrapper {
    position: absolute;
    bottom: 8px;
    display: flex;
    width: 100%;
    -webkit-box-pack: end;
    justify-content: flex-end;
    height: 24px;
    pointer-events: none;
    transition: color 300ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
    -webkit-box-align: center;
    align-items: center;
    white-space: nowrap;
  }
}
</style>
